<template>
    <div
        v-if="active"
        data-mock-mode-indicator
        class="fixed bottom-4 right-4 z-9999 flex items-center gap-3 rounded-full border border-amber-400/30 bg-amber-950/90 px-4 py-2 text-xs font-medium text-amber-200 shadow-lg backdrop-blur-sm"
    >
        <span class="inline-block size-2 animate-pulse rounded-full bg-amber-400" />
        <span>Mock Mode</span>
        <span
            v-if="scenarioLabel"
            class="text-amber-400/70"
        >
            · {{ scenarioLabel }}
        </span>
        <button
            class="ml-1 rounded-md px-2 py-0.5 text-amber-300 transition hover:bg-amber-800/60"
            @click="deactivate"
        >
            Deactivate
        </button>
    </div>
</template>

<script setup lang="ts">
    const { active, scenario, refresh, deactivate } = useMockMode()

    const scenarioLabel = computed(() => {
        if (!scenario.value || typeof scenario.value !== 'object') {
            return null
        }

        return scenario.value.name ?? scenario.value.seed ?? null
    })

    onMounted(() => {
        refresh()
    })
</script>
